import clsx from 'clsx'
import { useTranslations, useFormatter } from 'next-intl'

import Flex from '@/components/atoms/Flex'
import { Label } from '@/components/atoms/Typography'

import styles from './Deadline.module.scss'

const Deadline = ({
  deadline,
  autoWidth = false,
}: {
  deadline: string
  autoWidth?: boolean
}) => {
  const format = useFormatter()
  const dateTime = new Date(deadline)

  const t = useTranslations('General')

  return (
    <Flex
      className={clsx(
        'deadline',
        styles.deadline,
        autoWidth && styles.autoWidth
      )}
      gap='1rem'
      justifyContent='between'
    >
      <Label
        family='sans'
        size='lg'
        weight='medium'
        className={styles.deadlineLabel}
      >
        {t('deadline')}
      </Label>
      <Label
        family='sans'
        size='lg'
        weight='medium'
        className={styles.deadlineValue}
      >
        {format.dateTime(dateTime, 'deadline')}
      </Label>
    </Flex>
  )
}

export default Deadline
